import { render, staticRenderFns } from "./KaojiList.vue?vue&type=template&id=24c2b273&scoped=true&"
import script from "./KaojiList.vue?vue&type=script&lang=js&"
export * from "./KaojiList.vue?vue&type=script&lang=js&"
import style0 from "./KaojiList.vue?vue&type=style&index=0&id=24c2b273&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c2b273",
  null
  
)

export default component.exports